// src/components/MemeShowcase.js
import React from 'react';
import colors from '../colors';
import meme1 from '../assets/meme1.png';

function MemeShowcase() {
    const memes = [
        {
            id: 1,
            src: meme1,
            alt: 'Meme 1',
        }
    ];

    return (
        <section id="memeShowcase" style={styles.showcase}>
            {/*<h2 style={styles.heading}>Wisemoji Memes</h2>*/}
            <h1 style={styles.heading}>Blending wisdom & memes</h1>
            <div style={styles.grid}>
                {memes.map((meme) => (
                    <div key={meme.id} style={styles.item}>
                        <img src={meme.src} alt={meme.alt} style={styles.image} />
                    </div>
                ))}
            </div>
        </section>
    );
}

const styles = {
    showcase: {
        padding: '60px 20px',
        backgroundColor: colors.primaryDarker,
    },
    heading: {
        textAlign: 'center',
        color: colors.textLight,
        fontSize: '1.8rem',
        marginBottom: '40px',
    },
    grid: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '20px',
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: '10px',
        overflow: 'hidden',
        width: '300px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s, box-shadow 0.3s',
    },
    image: {
        width: '100%',
        height: 'auto',
        display: 'block',
    },
    // Add hover effect to the card
    cardHover: {
        transform: 'translateY(-10px)',
        boxShadow: '0 6px 10px rgba(0,0,0,0.15)',
    },
};

export default MemeShowcase;